import React, { useEffect }  from "react";
import { connect } from "react-redux";
import { useParams } from 'react-router-dom';
import PayslipDetails from "./components/PayslipDetails";
import { getPayslipDetails } from "../../../redux/payrun/payrunState";
import ButtonWithConfirm from "components/button/buttonwithconfirm";
import { 
	sendPayslip
} from "../../../redux/payrun/payrunState";

const FinanceView = ({getMyPayslip, doSendPayslip, recordData}) => {
	const { empCode, payrollId, encodedHash, encodedPin } = useParams();
	const securityCode = atob(encodedPin);
	const hash = atob(encodedHash);
	
  	useEffect(() => {
	    getMyPayslip({payrollId, empCode, hash, securityCode});
    }, [getMyPayslip, payrollId, empCode, hash, securityCode]);
	
	const sendPayslipHandler = () => {
		doSendPayslip(recordData?.ppr_id);
	}

	return (
    	<div>	    
	    	<PayslipDetails />	  
			<div className="flex flex-row-reverse text-right mt-3">		      			
				<ButtonWithConfirm className="btn-danger me-3" 
					confirmHandler={sendPayslipHandler}>
					Send Payslip
				</ButtonWithConfirm>
			</div>    	      	
	    </div>
    );
};

const mapStateToProps = (state) => ({
	recordData: state.payrun.payslipDetails?.data,	
});

const mapDispatchToProps = (dispatch) => ({
	getMyPayslip: (parameters) => dispatch(getPayslipDetails(parameters)),
	doSendPayslip: (id) => dispatch(sendPayslip(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FinanceView);